import {History} from '../../../graphql-typings/graphql';
import {PeriodFunction} from './period-function';
import {AccumulatingChartFunction, FunctionName} from './chart-function-types';
import {IterableUtil} from '@app/shared/util/collections/collection-utils';

export interface AverageContext {
  sum: number | null;
  count: number;
}

export class AverageFunction extends PeriodFunction implements AccumulatingChartFunction<AverageContext> {

  constructor() {
    super(FunctionName.AVG, 'Average');
  }

  run(historyArray: History[], padValues?: boolean): History[] {
    return this.applyPeriodFunction(historyArray, (ha: History[]) => this.getAggregate(this.accumulate(ha, null)), padValues);
  }

  accumulate(history: Iterable<History>, context: AverageContext | null): AverageContext {
    let sum: number | null = context?.sum ?? null;
    let count = context?.count ?? 0;
    IterableUtil.forEach(history, historyItem => {
      sum = (sum ?? 0) + historyItem.data;
      count++;
    });
    const newContext: AverageContext = {...context, sum, count};
    return newContext;
  }

  getAggregate(context: AverageContext): number {
    return (context.sum != null && context.count > 0)
      ? (context.sum / context.count)
      : null;
  }
}
